import { TableRow, TableCell } from "@mui/material";
import { IRow } from "../types";

export const form6HeaderRows = (
    <>
        <TableRow>
            <TableCell sx={{ whiteSpace: "pre-wrap" }} rowSpan={2}>
                Наименование Субсидии
            </TableCell>
            <TableCell sx={{ whiteSpace: "pre-wrap" }} rowSpan={2}>
                Цель предоставления субсидии*
            </TableCell>
            <TableCell sx={{ whiteSpace: "pre-wrap" }} rowSpan={2}>
                Поступления (всего), руб.
            </TableCell>
            <TableCell sx={{ whiteSpace: "pre-wrap" }} colSpan={2}>
                Выплаты
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell sx={{ whiteSpace: "pre-wrap" }}>всего, руб.</TableCell>
            <TableCell sx={{ whiteSpace: "pre-wrap" }}>из них возвращено в бюджет, руб.</TableCell>
        </TableRow>
    </>
);

export const form6Rows: IRow[] = [
    {
        col1: "Субсидия в целях оказания федеральным государственным учреждением дополнительной государственной поддержки, в том числе для реализации программ развития федеральных государственных учреждений, кадрового потенциала и материально-технической базы",
        col2: "Создание и развитие творческих инкубаторов и центров прототипирования",
        col3: { name: "info.f6.0", numeric: true },
        col4: { name: "info.f6.1", numeric: true },
        col5: { name: "info.f6.2", numeric: true },
    },
];
